import { useState, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../components/Modal';

const WithModal = ({ WrappedComponent, label, className, children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  return (
    <>
      <WrappedComponent label={label} className={className} onClick={handleModalOpen} />
      <Modal open={isModalOpen} onClose={handleModalClose}>
        {children}
      </Modal>
    </>
  );
};

WithModal.propTypes = {
  WrappedComponent: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default memo(WithModal);
